import $ from 'jquery'
import Isotope from 'isotope-layout'
import { debounce, getTextNodesIn } from '../functions'
import { createCookie } from '../global'
import {lockBody, unlockBody} from "../utils";


var placeIsoElement = document.querySelector('.js-places');

if (placeIsoElement) {
    var placeIso = new Isotope(placeIsoElement, {
        itemSelector: '.js-iso-item',
        filter: ':nth-child(-n+4)'
    });
}

const search = $('.js-search-iso').keyup(
    debounce(function () {
        var count = 0
      const qsRegex = new RegExp(search.val(), 'gi')

      placeIso.arrange({
        filter: function () {
          const post = $(this)
          const text = getTextNodesIn(post[0])

          let hasText = qsRegex ? text.match(qsRegex) : true
            if ( hasText ) {
                count++
            }

            if ( count > 4 ) {
                hasText = false
            }
          return hasText
        },
      })
    }, 200)
)

search.on('blur', function () {
  const qsRegex = new RegExp(search.val(), 'gi')
    var count = 0

  placeIso.arrange({
    filter: function () {
        const post = $(this)
        const text = getTextNodesIn(post[0])

        let hasText = qsRegex ? text.match(qsRegex) : true

        if ( hasText ) {
            count++
        }
        if ( count > 4 ) {
            hasText = false
        }

        return hasText
    },
  })
})

$('.js-place-select').on( 'click', function () {
    createCookie('selected_place_id', $(this).data('id') );
    location.reload();
})

$('.js-all-place-btn').on( 'click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    createCookie('selected_place_id', '' );

    window.location = $(this).attr('href')
})

$('.js-select-place').on( 'click', function (e) {
    $('.js-place-modal').fadeIn()
    placeIso.arrange()
})

$('.js-close-place-modal').on( 'click', function (e) {
    $('.js-place-modal').fadeOut()
})

$(document).click(function(event) {
    if ( ! $(event.target).closest('.back-office-header__place-modal--content').length && ! $(event.target).closest('.js-select-place').length ) {
        $('.js-place-modal').fadeOut();
    }
});

$('.js-open-mobile-bo-menu').on('click', function() {
    $('.js-top-part-header').fadeIn()
    $('.js-open-mobile-bo-menu').css('display', 'none')
    $('.js-close-mobile-bo-menu').css('display', 'flex')
    lockBody()
});

$('.js-close-mobile-bo-menu').on('click', function() {
    $('.js-top-part-header').fadeOut()
    $('.js-open-mobile-bo-menu').css('display', 'flex')
    $('.js-close-mobile-bo-menu').css('display', 'none')
    unlockBody()
});